import * as PropTypes from 'prop-types';
import * as React from 'react';
import { HashUtil } from '@reverbdotcom/discovery-ui';

class UserBadge extends React.Component {
  getLink() {
    const link = HashUtil.getSafely(this.props, 'countRecord._links.web.href');
    if (!link) { return; }

    // Remove domain to preseve ORIGIN for admin.reverb.tools
    const loc = new URL(link);
    return loc.pathname + loc.search + loc.hash;
  }

  hasCount() {
    return this.props.countRecord.count > 0 || this.props.persist;
  }

  hasDisplayText() {
    return !!this.props.countRecord.display_text;
  }

  shouldDisplay() {
    return this.hasCount() && this.hasDisplayText();
  }

  render() {
    if (this.shouldDisplay()) {
      return (
        <li>
          <a
            className="site-header__menu__link"
            href={this.getLink()}
            rel={this.props.rel}
            data-notification-count={this.props.countRecord.count}
          >
            {this.props.countRecord.display_text}
          </a>
        </li>
      );
    }

    return null;
  }
}

UserBadge.propTypes = {
  countRecord: PropTypes.object.isRequired,
  rel: PropTypes.string.isRequired,
  persist: PropTypes.bool,
};

UserBadge.defaultProps = {
  countRecord: {},
};

export default UserBadge;



// WEBPACK FOOTER //
// ./javascripts/components/user_badge.jsx